import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-707448c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "navbar",
  class: "navbar navbar-expand-sm navbar-light bg-light border-bottom"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "#"
}, " Negotiation ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  ref: "menu",
  class: "collapse navbar-collapse",
  id: "navbarNavAltMarkup"
}
const _hoisted_7 = {
  key: 0,
  class: "navbar-nav"
}
const _hoisted_8 = { class: "display-name nav-item dropdown" }
const _hoisted_9 = {
  ref: "userMenu",
  class: "dropdown-menu"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Chat ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Tags ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Users ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Export ")
const _hoisted_14 = {
  key: 0,
  class: "dropdown-divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu())),
            ref: "mobileMenuToggle",
            class: "navbar-toggler",
            type: "button",
            "aria-controls": "navbarNavAltMarkup",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation"
          }, _hoisted_5, 512))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.isAuthenticated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("li", _hoisted_8, [
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleMenu())),
                  class: "nav-link dropdown-toggle",
                  role: "button"
                }, _toDisplayString(_ctx.displayName), 1),
                _createElementVNode("ul", _hoisted_9, [
                  _createElementVNode("li", null, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleMenu())),
                          class: "nav-link dropdown-item",
                          "active-class": "active",
                          to: "/chat"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleMenu())),
                          class: "nav-link dropdown-item",
                          "active-class": "active",
                          to: "/tags"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleMenu())),
                          class: "nav-link dropdown-item",
                          "active-class": "active",
                          to: "/users"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleMenu())),
                          class: "nav-link dropdown-item",
                          "active-class": "active",
                          to: "/export"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createElementBlock("hr", _hoisted_14))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.logout())),
                      class: "logout nav-link dropdown-item"
                    }, " Logout ")
                  ])
                ], 512)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ])
  ], 512))
}